/** @prettier */

import baseFetch from '../baseFetch';
import addClientIpHeader from '../../utils/addClientIpHeader';

export const fetchSessionsClip = (clipId, cookies, clientIp) =>
  baseFetch(`/sessions/clips/${clipId}?`, {
    cookies,
    headers: {
      ...addClientIpHeader(clientIp),
    },
  });

export const fetchSession = (sessionId, cookies) =>
  baseFetch(`/sessions/${sessionId}/details?`, { cookies });
